var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 235,
    height: 41,
    viewBox: "0 0 235 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187.858 20.7868C186.912 20.1609 185.869 19.7159 184.881 19.1595C184.242 18.7979 183.56 18.4781 183.004 18.0191C182.058 17.2403 182.253 15.7104 183.24 15.0428C184.659 14.0971 187.009 14.6256 187.26 16.5588C187.26 16.6005 187.301 16.6283 187.343 16.6283H189.485C189.541 16.6283 189.582 16.5866 189.568 16.531C189.457 15.1958 188.942 14.0832 187.997 13.3739C187.093 12.6924 186.064 12.3308 184.965 12.3308C179.304 12.3308 178.79 18.3251 181.836 20.2165C182.183 20.4391 185.173 21.9411 186.23 22.5948C187.287 23.2484 187.621 24.4445 187.162 25.3902C186.745 26.2525 185.66 26.8506 184.575 26.781C183.393 26.7115 182.475 26.0717 182.155 25.0704C182.1 24.8896 182.072 24.5419 182.072 24.3889C182.072 24.3472 182.03 24.3054 181.989 24.3054H179.666C179.624 24.3054 179.583 24.3472 179.583 24.3889C179.583 26.0717 180 27.0035 181.14 27.8519C182.211 28.6586 183.379 28.9924 184.589 28.9924C187.76 28.9924 189.401 27.1983 189.735 25.3346C190.027 23.5127 189.485 21.8716 187.858 20.7868Z",
    fill: "#161616"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0122 12.6368H85.983H84.8565C84.8148 12.6368 84.787 12.6647 84.773 12.6925L82.8677 18.9788C82.8399 19.0622 82.7286 19.0622 82.7008 18.9788L80.7954 12.6925C80.7815 12.6507 80.7537 12.6368 80.712 12.6368H79.5854H78.5563H77.1655C77.1238 12.6368 77.082 12.6786 77.082 12.7203V28.7699C77.082 28.8116 77.1238 28.8533 77.1655 28.8533H79.4881C79.5298 28.8533 79.5715 28.8116 79.5715 28.7699V16.5727C79.5715 16.4754 79.7106 16.4615 79.7384 16.5449L81.6577 22.873L81.7968 23.318C81.8107 23.3598 81.8385 23.3737 81.8802 23.3737H83.6604C83.7021 23.3737 83.73 23.3458 83.7439 23.318L83.8829 22.873L85.8022 16.5449C85.83 16.4476 85.9691 16.4754 85.9691 16.5727V28.7699C85.9691 28.8116 86.0108 28.8533 86.0526 28.8533H88.3752C88.4169 28.8533 88.4586 28.8116 88.4586 28.7699V12.7203C88.4586 12.6786 88.4169 12.6368 88.3752 12.6368H87.0122Z",
    fill: "#161616"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M152.295 12.6368C152.254 12.6368 152.226 12.6647 152.212 12.6925L150.307 18.9788C150.279 19.0622 150.168 19.0622 150.14 18.9788L148.234 12.6925C148.22 12.6507 148.193 12.6368 148.151 12.6368H144.618C144.577 12.6368 144.535 12.6786 144.535 12.7203V28.7699C144.535 28.8116 144.577 28.8533 144.618 28.8533H146.941C146.983 28.8533 147.024 28.8116 147.024 28.7699V16.5727C147.024 16.4754 147.163 16.4615 147.191 16.5449L149.111 22.873L149.25 23.318C149.264 23.3598 149.291 23.3737 149.333 23.3737H151.113C151.155 23.3737 151.183 23.3458 151.197 23.318L151.336 22.873L153.255 16.5449C153.283 16.4476 153.422 16.4754 153.422 16.5727V28.7699C153.422 28.8116 153.464 28.8533 153.505 28.8533H155.828C155.87 28.8533 155.912 28.8116 155.912 28.7699V12.7203C155.912 12.6786 155.87 12.6368 155.828 12.6368H152.295Z",
    fill: "#161616"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M122.338 12.6368H118.013H115.69H111.365C111.323 12.6368 111.281 12.6786 111.281 12.7203V14.723C111.281 14.7647 111.323 14.8065 111.365 14.8065H115.607V28.7699C115.607 28.8116 115.648 28.8533 115.69 28.8533H118.013C118.054 28.8533 118.096 28.8116 118.096 28.7699V14.8065H122.338C122.38 14.8065 122.421 14.7647 122.421 14.723V12.7203C122.421 12.6786 122.394 12.6368 122.338 12.6368Z",
    fill: "#161616"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M136.037 28.8533H138.151C138.207 28.8533 138.249 28.7977 138.235 28.742L133.868 12.6368C133.854 12.5951 133.826 12.5812 133.784 12.5812H132.978H131.559H130.752C130.711 12.5812 130.683 12.609 130.669 12.6368L126.302 28.742C126.288 28.7977 126.33 28.8533 126.385 28.8533H128.499C128.541 28.8533 128.569 28.8255 128.583 28.7977L129.848 24.1107C129.862 24.069 129.89 24.0551 129.932 24.0551H134.605C134.646 24.0551 134.674 24.0829 134.688 24.1107L135.954 28.7977C135.968 28.8255 136.009 28.8533 136.037 28.8533ZM130.488 21.7603L132.185 15.4879C132.213 15.4045 132.324 15.4045 132.352 15.4879L134.048 21.7603C134.062 21.816 134.021 21.8716 133.965 21.8716H130.571C130.516 21.8716 130.474 21.816 130.488 21.7603Z",
    fill: "#161616"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M172.086 28.8533H174.2C174.256 28.8533 174.298 28.7977 174.284 28.742L169.917 12.6368C169.903 12.5951 169.875 12.5812 169.833 12.5812H169.027H167.608H166.801C166.76 12.5812 166.732 12.609 166.718 12.6368L162.351 28.742C162.337 28.7977 162.379 28.8533 162.434 28.8533H164.548C164.59 28.8533 164.618 28.8255 164.632 28.7977L165.897 24.1107C165.911 24.069 165.939 24.0551 165.981 24.0551H170.654C170.696 24.0551 170.723 24.0829 170.737 24.1107L172.003 28.7977C172.017 28.8255 172.045 28.8533 172.086 28.8533ZM166.537 21.7603L168.234 15.4879C168.262 15.4045 168.373 15.4045 168.401 15.4879L170.097 21.7603C170.111 21.816 170.07 21.8716 170.014 21.8716H166.621C166.565 21.8716 166.523 21.816 166.537 21.7603Z",
    fill: "#161616"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8882 26.4751V21.4961C97.8882 21.4544 97.9299 21.4127 97.9716 21.4127H104.161C104.202 21.4127 104.244 21.3709 104.244 21.3292V19.3265C104.244 19.2848 104.202 19.2431 104.161 19.2431H97.9716C97.9299 19.2431 97.8882 19.2013 97.8882 19.1596V14.9038C97.8882 14.8621 97.9299 14.8204 97.9716 14.8204H105.009C105.051 14.8204 105.092 14.7787 105.092 14.7369V12.7342C105.092 12.6925 105.051 12.6508 105.009 12.6508H97.8882H95.4821C95.4404 12.6508 95.3987 12.6925 95.3987 12.7342V14.8204V19.257V21.4266V26.5725V28.7699C95.3987 28.8116 95.4404 28.8533 95.4821 28.8533H97.8882H105.301C105.343 28.8533 105.384 28.8116 105.384 28.7699V26.6559C105.384 26.6142 105.343 26.5725 105.301 26.5725H97.9577C97.916 26.5586 97.8882 26.5307 97.8882 26.4751Z",
    fill: "#161616"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M209.081 28.7143L201.042 20.4113C201.014 20.3835 201.014 20.3279 201.042 20.3L208.274 12.7898C208.33 12.7342 208.288 12.6508 208.219 12.6508H205.256C205.228 12.6508 205.215 12.6647 205.201 12.6786L199.067 19.0483C199.012 19.104 198.928 19.0623 198.928 18.9927V12.7342C198.928 12.6925 198.886 12.6508 198.845 12.6508H196.522C196.48 12.6508 196.439 12.6925 196.439 12.7342V28.7838C196.439 28.8255 196.48 28.8673 196.522 28.8673H198.845C198.886 28.8673 198.928 28.8255 198.928 28.7838V21.7186C198.928 21.6491 199.026 21.6074 199.067 21.663L206.021 28.8394C206.035 28.8533 206.063 28.8673 206.077 28.8673H209.039C209.095 28.8533 209.137 28.756 209.081 28.7143Z",
    fill: "#161616"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2131 4L47.1523 14.4309L49.767 8.2836L61.2131 4Z",
    fill: "#E17726",
    stroke: "#E17726",
    strokeWidth: 0.139078,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.78 4L42.7156 14.5282L40.2261 8.2836L28.78 4Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.139078,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1506 28.1857L52.4094 33.9157L60.4203 36.127L62.7151 28.3108L56.1506 28.1857Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.139078,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.292 28.3108L29.5729 36.127L37.5699 33.9157L33.8426 28.1857L27.292 28.3108Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.139078,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1388 18.5058L34.9136 21.8715L42.841 22.2331L42.5768 13.6798L37.1388 18.5058Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.139078,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8545 18.5059L47.3331 13.5825L47.1523 22.2332L55.0798 21.8716L52.8545 18.5059Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.139078,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5698 33.9157L42.368 31.5931L38.2374 28.3665L37.5698 33.9157Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.139078,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6252 31.5931L52.4095 33.9157L51.7559 28.3665L47.6252 31.5931Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.139078,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4095 33.9156L47.6252 31.593L48.0147 34.7084L47.9729 36.0296L52.4095 33.9156Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.139078,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5698 33.9156L42.0203 36.0296L41.9925 34.7084L42.368 31.593L37.5698 33.9156Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.139078,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1039 26.3081L38.1262 25.1399L40.9356 23.8464L42.1039 26.3081Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.139078,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8896 26.3081L49.0579 23.8464L51.8812 25.1399L47.8896 26.3081Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.139078,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5698 33.9157L38.2652 28.1857L33.8425 28.3108L37.5698 33.9157Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.139078,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M51.728 28.1857L52.4095 33.9157L56.1507 28.3108L51.728 28.1857Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.139078,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0798 21.8716L47.1523 22.2332L47.8895 26.3082L49.0577 23.8465L51.881 25.1399L55.0798 21.8716Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.139078,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M38.126 25.1399L40.9354 23.8465L42.1037 26.3082L42.8408 22.2332L34.9133 21.8716L38.126 25.1399Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.139078,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9136 21.8716L38.2375 28.3665L38.1263 25.1399L34.9136 21.8716Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.139078,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M51.881 25.1399L51.7559 28.3665L55.0798 21.8716L51.881 25.1399Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.139078,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8411 22.2332L42.104 26.3081L43.0358 31.1202L43.2444 24.7783L42.8411 22.2332Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.139078,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1524 22.2332L46.7629 24.7644L46.9576 31.1202L47.8895 26.3081L47.1524 22.2332Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.139078,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8896 26.3081L46.9578 31.1202L47.6253 31.5931L51.756 28.3665L51.8811 25.1399L47.8896 26.3081Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.139078,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1262 25.1399L38.2375 28.3665L42.3681 31.5931L43.0357 31.1202L42.1039 26.3081L38.1262 25.1399Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.139078,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9729 36.0296L48.0146 34.7084L47.653 34.4024H42.3402L41.9925 34.7084L42.0203 36.0296L37.5698 33.9156L39.1275 35.1952L42.2846 37.3787H47.6947L50.8657 35.1952L52.4095 33.9156L47.9729 36.0296Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D",
    strokeWidth: 0.139078,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6253 31.5931L46.9578 31.1202H43.0358L42.3682 31.5931L41.9927 34.7085L42.3404 34.4025H47.6532L48.0148 34.7085L47.6253 31.5931Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.139078,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8112 15.1123L62.9934 9.3545L61.2132 4L47.6252 14.0832L52.8546 18.5058L60.2396 20.6615L61.8668 18.7562L61.1575 18.2416L62.2841 17.2124L61.4218 16.5448L62.5483 15.6826L61.8112 15.1123Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.139078,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M27 9.3545L28.1961 15.1123L27.4311 15.6826L28.5716 16.5448L27.7093 17.2124L28.8358 18.2416L28.1265 18.7562L29.7537 20.6615L37.1388 18.5058L42.3681 14.0832L28.7802 4L27 9.3545Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.139078,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2396 20.6616L52.8546 18.5059L55.0798 21.8715L51.7559 28.3665L56.1507 28.3109H62.7152L60.2396 20.6616Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.139078,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1387 18.5059L29.7537 20.6616L27.292 28.3109H33.8426L38.2374 28.3665L34.9135 21.8715L37.1387 18.5059Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.139078,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1524 22.2331L47.6253 14.0831L49.7671 8.28357H40.2263L42.3681 14.0831L42.841 22.2331L43.0218 24.7921L43.0357 31.1202H46.9577L46.9716 24.7921L47.1524 22.2331Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.139078,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.6b4c8d4eefcdebe80978c36eec55e437.svg";
export { ForwardRef as ReactComponent };